import type { LocationNameInput } from "common/types/schema";

export const formatAddress = (location: LocationNameInput, multiLine?: boolean) => {
  const seperator = multiLine ? "\n" : ", ";
  return [location.address, location.city, location.postcode].filter((x) => x).join(seperator);
};
